// extracted by mini-css-extract-plugin
export var currencyInput = "_n1-1";
export var currencySymbol = "_n1-0";